import React from "react"
import styled from "styled-components"
import { themes } from "../styles/ColorStyles"

const nm = themes.neumorphic

function MeSection(){
  return (
    <Wrapper>
      <ContentWrapper>
        <TextWrapper>
          <Description>
          I am a Research Scientist at Adobe Research, where I lead multiple research-to-production projects in generative image and video editing. My work spans unified editing frameworks (EditVerse, ICLR'26 Oral), generative video propagation (GenProp, Adobe MAX Sneak 2025), and physically-grounded shadow understanding (MetaShadow, shipped in Lightroom & Photoshop). I am equally driven by fundamental questions — how should we train visual generative models from scratch, and can editing and generation be unified into a single paradigm? These threads are converging on my broader vision: building world-aware visual foundation models that inherently understand the physical constraints of our world. I received my Ph.D. from The Chinese University of Hong Kong, advised by Prof. Chi-Wing Fu. When I'm not pushing pixels through neural networks, I'm exposing them on film — a slower way of seeing that keeps me close to the beauty I'm trying to teach machines to understand.
          </Description>
        </TextWrapper>
      </ContentWrapper>
    </Wrapper>
  )
}

export default MeSection

const TextWrapper = styled.div`
  display: grid;
`

const Description = styled.p`
  font-family: bree, sans-serif;
  font-size: 18px;
  line-height: 1.7;
  color: ${nm.text2};

  @media (max-width: 1274px) {
    margin-left: 30px;
    margin-right: 30px;
  }
  @media (max-width: 850px) {
    margin-left: 30px;
    margin-right: 30px;
    font-size: 16px;
  }
`

const Wrapper = styled.div`
  overflow: hidden;
  height: auto;
  background: ${nm.bg};
  padding: 60px 0;
`

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: auto;

  @media (max-width: 850px) {
    height: auto;
  }
`
